<template>
	<div>
		<br><br><br><br><br><br>
		<div class="staking-text">
			NinjaShrimps (NS) hodlers will be able to stake their NFTs to earn NinjaShrimp tokens (NSTs). 
			These Ninjas will earn their hodlers different token yields based on their rarity or class of ninja they belong,
			<ul>
				<li>Chunin: 20 NSTs per day</li>
				<li>Jonin: 40 NSTs per day</li>
				<li>Sage and Rouges: 70 NSTs per day</li>
				<li>Hockage: 120 NSTs per day</li>
			</ul>
			Currently, NSTs should be accumulated for breeding male and female Ninja. All future utility will be announced on Twitter.
		</div>

		<div v-if="collectable.gettingUserNFTs" class="text-center">
			<div class="spinner-border" style="border-color: white; border-right-color: transparent; width: 8rem; height: 8rem;" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>

		<div v-else>
			<div class="d-none d-md-flex container nfts-container">
				<div class="card-container" v-for="(nft, index) in collectable.userNFTs" :key="index">
					<img class="sword-gif" :src="getImageURL(nft)" alt="" />					
					<div class="text-rarity">
						{{ nft.rarityClass }}
					</div>
					<div class="data">
						<div class="text">NSTs earned: </div>						
						<div class="coin-gif"></div>
						<div class="text"> {{ parseFloat(nft.reward).toFixed(3) }} </div>
					</div>
					
					<button v-if="nft.rarity == 0" @click="stakeNFT(nft.id, nft.rarityBackend)" type="button" class="button-connect">STAKE</button>
					<button v-else :disabled="nft.reward == 0" @click="claimRewardsNFT(nft.id)" type="button" :class="`button-connect ${nft.reward == 0 ? 'button-connect-disabled' : ''}`">CLAIM</button>
					<br><br><br><br>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import { Splide, SplideSlide } from '@splidejs/vue-splide';
	import NSTServices from "../services/token"
	import '@splidejs/splide/dist/css/themes/splide-default.min.css';
	import axios from 'axios';
	import NetworkService from '../services/network';

	export default {
		name: 'myDojo',
		components:{ Splide, SplideSlide },
		data(){
			return {}
		},
		methods: {
			...mapActions("collectable", ["getUserTokens", "updateTotalClaimable"]),
			getImageURL(nft) {
				// if(['111', '333', '777', '1111', '1499', '1998'].includes(nft.id.toString()) ) {
				// 	return `https://storage.googleapis.com/vsamurai-images/${nft.id}.gif`
				// }
				// return `https://storage.googleapis.com/vsamurai-images/${nft.id}.png`
				return nft.uri
			},
		async stakeNFT(nftId, rarity){
			let apiBaseURI = process.env.API_URI;
			let chainId = await NetworkService.getNetworkId();
			let address = this.wallet.address;
			let apiURL = `${apiBaseURI}/api/signatures/rarity?chainId=${chainId}&address=${address}&nftId=${nftId}`
			// console.log('Stake apiURL', apiURL);
			let signature = await axios.get(apiURL)
				.then(res => {
					return res.data;
				})
				.catch(e => console.log(e))
			await NSTServices.registerForRewards(signature, nftId, rarity)
			await this.getUserTokens({})
		},
		async claimRewardsNFT(nftId){
			await NSTServices.claimRewards(nftId)
			await this.getUserTokens({})
		},
		async rarities(nftId){
			return await NSTServices.rarities(nftId)
		},
		},
		computed: {
			...mapState('collectable', ['collectable']),
			...mapState('wallet', ['wallet']),
			console: () => console,
		},
	}
</script>

<style scoped>
	.splide__pagination {
			bottom: -90px;
	}
	.splide__pagination__page {
		opacity: 1;
		width: 17px;
		height: 17px;
		margin: 0px 6px;
		background: transparent;
		border: 1px solid white;
	}
	.splide__pagination__page.is-active {
		border: 1px solid #F28B2E;
		background: #F28B2E!important;
		transform: none!important
	}
	.container-header{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 100px;
		margin-bottom: 80px;
	}

	.coin-gif {
		background-image: url("../assets/img/staking-img/nst-coinn-anim.gif");
    background-repeat: no-repeat;
    background-size: contain;
    height: 25px;
    width: 25px;
    margin: auto;
	}

	.ellipse-1 {
		position: absolute;
		left: 0;
		margin-top: -230px;
	}

	.ellipse-2 {
		position: absolute;
		right: 0;
		margin-top: 183px;
	}

	.nfts-container {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		z-index: 1000;
		max-width: 1600px;
	}

	.card-container {
		margin: 10px 22px;
		width: 300px;
		display: flex;
		justify-content: center;
		flex-direction: column;
	}

	.data {
		/* display: flex; */
		margin-top: 20px;
		margin-bottom: 10px;
		/* margin-left: 26px;
		justify-content: space-between; */
	}

	.text {
		font-family: 'Raleway';
		font-size: 18px;
		text-align: center;
		color: #FFFFFF;
		letter-spacing: 2px;
	}
	.text-rarity {
		font-family: 'Raleway';
		font-size: 18px;
		text-align: center;
		color: #FFFFFF;
		letter-spacing: 2px;
		height: 24px;
		margin-top: 20px;
	}

	.token {
		width: 54px;
		height: 54px;
		background: white;
		border-radius: 50%;
	}

	.container-header div{
		font-family: 'pixel-point';
		color: #EF0A0A;
		font-size: 42px;
		text-align: center;
		height: 100px;
	}

	.staking-text {
		max-width: 1360px;
		font-family: 'Raleway';
		font-size: 24px;   
		color: #FFFFFF;
		margin: auto;
		letter-spacing: 2px;
		margin-bottom: 80px;
	}

	ul {
		margin: 20px;
	}

	p{
		max-width: 1360px;
		height: 196px;
		font-family: 'Raleway';
		font-size: 24px;   
		color: #FFFFFF;
		margin: 20px auto;
		text-align: center;
		font-weight: 600;
	}

	.line {
		margin: auto;
		max-width: 1000px;
		height: 3px;
		color: #03738B;
	}
	.vector {
		position: absolute;
		left: 0;
		margin-top: -40px;
		opacity: 0.5;
	}
	.staking-text {
		max-width: 1200px;
	}
	/* .image-nft {
		max-width: 250px;
	} */
	.image-nft{
		background-image:url('../assets/img/staking-img/staking.png');
		background-repeat:no-repeat;
		background-size: cover;
		width:250px;
		height:250px;
		background-position:center;
		border-radius: 50%;
		border: none;
		background-color: transparent;
	}

	@media (max-width: 1400px) {
		p {
			font-size: 20px;
			max-width: 1000px;
			padding: 10px;
		}
		.staking-text {
			max-width: 1000px;
		}
	}

	@media (max-width: 1200px) {
		.line {
			max-width: 800px;
		}
		.staking-text {
			max-width: 700px;
			font-size: 16px;
			padding: 20px;
		}
	}

	@media (max-width: 950px) {
	.line {
		max-width: 700px;
		}
		.bottom-container p {
		font-size: 20px;
		}
	}

	@media (max-width: 730px) {
	.line {
			max-width: 500px;
			margin-top: 100px;
		}
		.bottom-container p {
			font-size: 15px;
		}
	}

	@media (max-width: 625px) {
		.header {
			font-size: 26px !important;
			height: 50px !important;
		}
		.staking-text {
			font-size: 16px;
			margin: 20px;
			margin-bottom: 100px;
		}
		.line {
			max-width: 310px;
		}
		.vector {
			left: -35px;
		}
		.bottom-container{
			margin-top: 160px;
		}
		.text{
			font-size: 13px;
			margin-left: -14px;
		}
		.coin-gif{
			margin-top: -4px;
			margin-left: 11px;
		}
		.image-nft{
			width:200px;
			height:200px;
		}
	}
</style>


